'use client';
import { Suspense } from 'react';
import useInView from '@/utils/useInView';

// Some third-party widgets (e.g. the logo carousel) run continuous work
// (rAF-driven auto-scroll) for as long as they're mounted, even off-screen.
// Delay mounting until the wrapper actually scrolls into view.
export default function LazyMountOnVisible({ children, fallback = null, rootMargin }) {
  const [ref, inView] = useInView({ rootMargin });

  return (
    <div ref={ref}>
      {inView && <Suspense fallback={fallback}>{children}</Suspense>}
    </div>
  );
}
